<form [formGroup]="form"
  data-qa="planwert-detail-form"
  fxLayout="column"
>
  <header>
    <div>

    </div>

    <div class="header-container">
      <div>
        <h1>Planwerte erfassen/bearbeiten:</h1>
        <h4 class="caption-text">Hier erfassen und bearbeiten Sie Planwerte für die Erzeugungsanlage:</h4>
      </div>
      <div class="dokumentenId">
        <div>Dokumenten-ID:</div>
        <span class="dokumentenId-title" data-qa="dokumenten-id">
          <span>{{ dokumentenId }}</span>
        </span>
      </div>
    </div>

    <div class="buttons">
        <button (click)="closeSideNav()"
                data-qa="close-details-button"
                type="button"
                matButton="outlined">
            <mat-icon svgIcon="innogy_picto_close"></mat-icon>
            Schließen
        </button>
        @if (!readonly) {
            <button (click)="resetForm()"
                    [disabled]="!form.dirty"
                    class="actionbutton"
                    data-qa="reset-button"
                    type="button"
                    matButton="outlined">
                <mat-icon>autorenew</mat-icon>
                Zurücksetzen
            </button>
        }

      @if (!readonly) {
        <button (click)="createOrUpdatePlanwert()"
          [disabled]="isSaveOrCreateButtonDisabled()"
          class="actionbutton"
          data-qa="save-button"
                type="button"
          matButton="filled">
          <mat-icon>save</mat-icon>
          Speichern
        </button>
      }
        @if (!readonly && showDeleteButton) {
            <button
                (click)="deletePlanwert()"
                class="button-warn actionbutton"
                data-qa="delete-button"
                type="button"
                matButton="filled">
                <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
                Löschen
            </button>
        }
    </div>

  </header>

  <div class="input-container" fxFlex fxLayout="column">

    <div class="redispatchPlanwerteBasisdaten" fxFlex fxLayout="column">
      <redispatch-form-group-headline [feld]="Feld.HEADER_BASISDATA"
      [showInfo]="true"></redispatch-form-group-headline>
        <mat-card>
          <div class="planwert-form">
                <mat-form-field>
                    <mat-label>Bezeichnung VNB intern</mat-label>
                    <input name="vnbInternalLabel"
                           matInput
                           disabled
                           value="{{erzeugungsanlage?.bezVnbIntern}}"
                    />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>TR-ID</mat-label>
                    <input name="trId"
                           matInput
                           disabled
                           value="{{erzeugungsanlage?.resourceIds?.technischeResourceId}}"
                    />
                </mat-form-field>
                <mat-form-field class="netzverknuefungspunkt">
                    <mat-label>Netzverknüpfungspunkt (kompakt)</mat-label>
                    <input name="netzverknuefpungsPunkt"
                           matInput
                           disabled
                           value="{{getNetzverknuefungspunktCompactValue()}}"
                    />
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Gültig ab</mat-label>
                  <input name="planwertGueltigAb"
                         matInput
                         disabled
                         value="{{erzeugungsanlage?.gueltigAb | date: 'dd.MM.yyyy'}}"
                  />
                </mat-form-field>
            </div>
        </mat-card>
    </div>

    <div fxLayout="column">
      <div class="redispatchPlanwerteBruttonennleistung">
        <redispatch-form-group-headline [feld]="Feld.HEADER_LEISTUNG"
        [showInfo]="true"></redispatch-form-group-headline>
        <ng-container
          *ngTemplateOutlet="planwertItemForm; context:{ formGroup: 'bruttonennleistung', formCaption: 'Bruttonennleistung' }"
        ></ng-container>
      </div>

      <div class="redispatchPlanwerteSgId">
        <redispatch-form-group-headline [feld]="Feld.HEADER_RESOURCE_IDS"
        [showInfo]="true"></redispatch-form-group-headline>
        <ng-container
          *ngTemplateOutlet="planwertItemForm; context:{ formGroup: 'srId', formCaption: 'SR-ID' }"
        ></ng-container>
        <ng-container
          *ngTemplateOutlet="planwertItemForm; context:{ formGroup: 'sgId', formCaption: 'SG-ID' }"
        ></ng-container>
      </div>

      <div class="redispatchRelevanceColor{{erzeugungsanlage?.redispatchRelevant === true ? 'True' : 'False'}}" style="margin-bottom: 15px;">
        <mat-icon aria-label="Redispatch relevanz"
                  [svgIcon]="erzeugungsanlage?.redispatchRelevant === true ? 'innogy_picto_check' : 'innogy_picto_close'">
        </mat-icon>
        <span style="margin: 5px;">
          Diese Anlage ist
          {{erzeugungsanlage?.redispatchRelevant === false ? 'nicht' : ''}}
          Redispatch relevant,
          {{erzeugungsanlage?.redispatchRelevant === false ? 'deshalb werden weitere Planwert-Felder nicht angezeigt' : 'daher können Sie folgende Planwerte pflegen'}}
        </span>
      </div>

      @if (erzeugungsanlage?.redispatchRelevant) {
        <div class="redispatchPlanwerteTr">
          <redispatch-form-group-headline [feld]="Feld.HEADER_REDISPATCH_TR"
          [showInfo]="true"></redispatch-form-group-headline>
          <ng-container
            *ngTemplateOutlet="planwertItemForm; context:{ formGroup: 'anlagebetreiberName', formCaption: 'Anlagenbetreiber Name' }"
          ></ng-container>
          <ng-container
            *ngTemplateOutlet="planwertItemForm; context:{ formGroup: 'anlagebetreiberStrasse', formCaption: 'Anlagenbetreiber Str.' }"
          ></ng-container>
          <ng-container
            *ngTemplateOutlet="planwertItemForm; context:{ formGroup: 'anlagebetreiberHausnummer', formCaption: 'Anlagenbetreiber Hausnummer' }"
          ></ng-container>
          <ng-container
            *ngTemplateOutlet="planwertItemForm; context:{ formGroup: 'anlagebetreiberHausnummerZusatz', formCaption: 'Anlagenbetreiber Hausnummerzusatz' }"
          ></ng-container>
          <ng-container
            *ngTemplateOutlet="planwertItemForm; context:{ formGroup: 'anlagebetreiberPlz', formCaption: 'Anlagenbetreiber PLZ' }"
          ></ng-container>
          <ng-container
            *ngTemplateOutlet="planwertItemForm; context:{ formGroup: 'anlagebetreiberOrt', formCaption: 'Anlagenbetreiber Ort' }"
          ></ng-container>
        </div>
      }

      @if (erzeugungsanlage?.redispatchRelevant) {
        <div class="redispatchPlanwerteTrMarktlokation">
          <redispatch-form-group-headline [feld]="Feld.HEADER_TR_MARKTLOKATION"
          [showInfo]="true"></redispatch-form-group-headline>
          <ng-container
            *ngTemplateOutlet="planwertItemForm; context:{ formGroup: 'marktlokation', formCaption: 'Marktlokation' }"
          ></ng-container>
          <ng-container
            *ngTemplateOutlet="planwertItemForm; context:{ formGroup: 'bilanzkreis', formCaption: 'Identifikator des Bilanzkreis' }"
          ></ng-container>
          <ng-container
            *ngTemplateOutlet="planwertItemForm; context:{ formGroup: 'lieferant', formCaption: 'Lieferant-Marktlokation' }"
          ></ng-container>
        </div>
      }

      @if (erzeugungsanlage?.redispatchRelevant) {
        <div class="redispatchPlanwerteTrTranche">
          <redispatch-form-group-headline [feld]="Feld.HEADER_TR_TRANCHE"
          [showInfo]="true"></redispatch-form-group-headline>
          <ng-container
            *ngTemplateOutlet="planwertItemForm; context:{ parentFormGroup: Feld.HEADER_TR_TRANCHE, formGroup: 'trancheMarktlokation', formCaption: 'Marktlokation Tranche' }"
          ></ng-container>
          <ng-container
            *ngTemplateOutlet="planwertItemForm; context:{ parentFormGroup: Feld.HEADER_TR_TRANCHE, formGroup: 'trancheBilanzkreis', formCaption: 'Bilanzkreis Tranche' }"
          ></ng-container>
          <ng-container
            *ngTemplateOutlet="planwertItemForm; context:{ parentFormGroup: Feld.HEADER_TR_TRANCHE, formGroup: 'trancheLieferant', formCaption: 'Lieferant Tranche' }"
          ></ng-container>
          <ng-container
            *ngTemplateOutlet="planwertItemForm; context:{ parentFormGroup: Feld.HEADER_TR_TRANCHE, formGroup: 'tranchenGroesse', formCaption: 'Tranchengröße [%]' }"
          ></ng-container>
        </div>
      }
    </div>

    <ng-template #planwertItemForm let-form_Group_Name="formGroup" let-form_Group_Caption="formCaption" let-parent_Form_Group="parentFormGroup">
      <mat-card formGroupName="{{form_Group_Name}}" class="planwert-item-form">
        <div style="word-break: break-word">{{form_Group_Caption}}</div>
        <div class="planwert-form">
          <mat-form-field class="originalValue">
            <mat-label>IST-Wert</mat-label>
            <input formControlName="originalValue"
              data-qa="original-value"
              name="originalValue"
              matInput
              />
          </mat-form-field>
          <mat-form-field class="plannedValue" id="plannedValue">
            <mat-label>SOLL-Wert</mat-label>
            <input
              formControlName="plannedValue"
              data-qa="planned-value"
              [required]="hasTrancheAnyPlannedValue(parent_Form_Group)"
              matInput
              />
            <mat-error>
              @for (key of objectKeys(planwertItemFormControl(form_Group_Name).get('validationErrorMessage').value); track key) {
                @if (!!planwertItemFormControl(form_Group_Name).get('plannedValue').errors && planwertItemFormControl(form_Group_Name).get('plannedValue').errors[key]) {
                  {{ planwertItemFormControl(form_Group_Name).get('validationErrorMessage').value[key] }}
                }
              }
            </mat-error>

          </mat-form-field>
          <mat-form-field class="dataTransferDate" matTooltip="Bei Übernahme der Planwerte zum angegebenen Datum, wird dieses zum 'Gültig ab' Datum">
            <mat-label>Datum</mat-label>
            <input formControlName="dataTransferDate"
              data-qa="data-transfer-date"
              [min]="PLANWERT_MIN_DATE"
              [matDatepicker]="planwerteDatepicker"
              [required]="hasPlannedValue(form_Group_Name)"
              matInput
              name="dataTransferDate"
              (focus)="planwerteDatepicker.open()"/>
            <mat-datepicker-toggle matSuffix [for]="planwerteDatepicker"
            data-qa="data-transfer-date-datepicker-toggle">
              <mat-icon matDatepickerToggleIcon svgIcon="innogy_picto_calendar-date-year"></mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #planwerteDatepicker></mat-datepicker>
            @if (planwertItemFormControl(form_Group_Name).get('dataTransferDate').hasError('matDatepickerMin')) {
              <mat-error>
                Bitte geben Sie nur zukünftige Daten ein.
              </mat-error>
            }
            @if (planwertItemFormControl(form_Group_Name).get('dataTransferDate').hasError('wrongDate')) {
              <mat-error>
                Das Planwert Datum der 4 Tranchenfelder muss identisch sein.
              </mat-error>
            }
            @if (planwertItemFormControl(form_Group_Name).get('dataTransferDate').hasError('dateRequired')) {
              <mat-error>
                Bitte geben Sie ein Datum ein.
              </mat-error>
            }
          </mat-form-field>

          @if (!readonly) {
            <button mat-icon-button class="formAction-delete button-warn"
                    type="button"
                    [disabled]="!isInStatusOpenOrUnset(form_Group_Name)"
              >
              <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
            </button>
          }
          <mat-form-field class="status">
            <mat-label>Status</mat-label>
            <input
              formControlName="status"
              name="status"
              data-qa="status"
              matInput
              />
          </mat-form-field>
          <mat-form-field style="display: none;">
            <input
              formControlName="statusHidden"
              name="statusHidden"
              data-qa="statusHidden"
              matInput
              />
          </mat-form-field>
          <mat-form-field class="errorMessage">
            <mat-label>Fehler-Text zu Planwert</mat-label>
            <input formControlName="errorMessage"
              data-qa="errorMessage"
              matInput
              name="errorMessage"
              />
          </mat-form-field>
        </div>
      </mat-card>
    </ng-template>

    <mat-divider></mat-divider>
  </div>
</form>
